// extracted by mini-css-extract-plugin
module.exports = {"text":"ProjectEditCard_text__3JYCF"};